var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFortunio({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 70.49 97.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-4 {\n        fill: url(#Gradient_16);\n      }\n\n      .cls-5 {\n        fill: url(#Gradient_25);\n      }\n\n      .cls-6 {\n        fill: url(#Gradient_38);\n      }\n\n      .cls-7 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-8 {\n        fill: #f7ee6f;\n      }\n\n      .cls-9 {\n        fill: #f58638;\n      }\n\n      .cls-10 {\n        fill: #f7d655;\n      }\n\n      .cls-11 {\n        fill: #675968;\n      }\n\n      .cls-12 {\n        fill: #e98d54;\n      }\n\n      .cls-13 {\n        fill: #fff;\n      }\n\n      .cls-14 {\n        fill: #faf3d7;\n      }\n\n      .cls-15 {\n        fill: #321917;\n      }\n\n      .cls-16 {\n        fill: #bd3b27;\n      }\n\n      .cls-17 {\n        fill: #ce5954;\n      }\n\n      .cls-18, .cls-19 {\n        fill: #cb4828;\n      }\n\n      .cls-20 {\n        fill: #c55c28;\n      }\n\n      .cls-21 {\n        fill: #e15a26;\n      }\n\n      .cls-22 {\n        fill: #231e23;\n      }\n\n      .cls-23 {\n        fill: #427d8d;\n      }\n\n      .cls-24 {\n        fill: #3c323d;\n      }\n\n      .cls-25 {\n        fill: #471523;\n      }\n\n      .cls-26 {\n        fill: #504450;\n      }\n\n      .cls-27 {\n        fill: url(#Gradient_75);\n      }\n\n      .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33, .cls-34, .cls-35, .cls-36, .cls-37, .cls-38, .cls-39, .cls-40 {\n        mix-blend-mode: multiply;\n      }\n\n      .cls-27, .cls-28, .cls-29, .cls-31, .cls-32, .cls-33, .cls-34, .cls-35, .cls-36, .cls-37, .cls-38, .cls-39, .cls-40 {\n        opacity: .45;\n      }\n\n      .cls-28 {\n        fill: url(#Gradient_13);\n      }\n\n      .cls-29 {\n        fill: url(#Gradient_82);\n      }\n\n      .cls-19 {\n        opacity: .2;\n      }\n\n      .cls-41 {\n        fill: url(#Gradient_25-2);\n      }\n\n      .cls-42 {\n        fill: url(#Gradient_38-6);\n      }\n\n      .cls-43 {\n        fill: url(#Gradient_38-4);\n      }\n\n      .cls-44 {\n        fill: url(#Gradient_38-7);\n      }\n\n      .cls-45 {\n        fill: url(#Gradient_38-9);\n      }\n\n      .cls-46 {\n        fill: url(#Gradient_38-8);\n      }\n\n      .cls-47 {\n        fill: url(#Gradient_38-5);\n      }\n\n      .cls-48 {\n        fill: url(#Gradient_38-3);\n      }\n\n      .cls-49 {\n        fill: url(#Gradient_38-2);\n      }\n\n      .cls-50 {\n        fill: url(#Gradient_16-5);\n      }\n\n      .cls-51 {\n        fill: url(#Gradient_16-4);\n      }\n\n      .cls-52 {\n        fill: url(#Gradient_16-7);\n      }\n\n      .cls-53 {\n        fill: url(#Gradient_16-2);\n      }\n\n      .cls-54 {\n        fill: url(#Gradient_16-6);\n      }\n\n      .cls-55 {\n        fill: url(#Gradient_16-3);\n      }\n\n      .cls-56 {\n        fill: url(#Gradient_16-9);\n      }\n\n      .cls-57 {\n        fill: url(#Gradient_16-8);\n      }\n\n      .cls-58 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-59 {\n        fill: url(#Gradient);\n      }\n\n      .cls-60 {\n        isolation: isolate;\n      }\n\n      .cls-30 {\n        fill: url(#Gradient_82-3);\n        opacity: .65;\n      }\n\n      .cls-31 {\n        fill: url(#Gradient_82-2);\n      }\n\n      .cls-32 {\n        fill: url(#Gradient_75-5);\n      }\n\n      .cls-33 {\n        fill: url(#Gradient_75-6);\n      }\n\n      .cls-34 {\n        fill: url(#Gradient_75-4);\n      }\n\n      .cls-35 {\n        fill: url(#Gradient_75-7);\n      }\n\n      .cls-36 {\n        fill: url(#Gradient_75-3);\n      }\n\n      .cls-37 {\n        fill: url(#Gradient_75-2);\n      }\n\n      .cls-38 {\n        fill: url(#Gradient_13-2);\n      }\n\n      .cls-39 {\n        fill: url(#Gradient_13-3);\n      }\n\n      .cls-40 {\n        fill: url(#Gradient_13-4);\n      }\n\n      .cls-2 {\n        stroke: #bd3b27;\n        stroke-miterlimit: 10;\n        stroke-width: .25px;\n      }\n\n      .cls-61 {\n        fill: url(#Gradient_38-10);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_38",
    "data-name": "Gradient 38",
    x1: 6.46,
    y1: 72.04,
    x2: 2.29,
    y2: 59.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bc3000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#921615"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#730325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_38-2",
    "data-name": "Gradient 38",
    x1: 14.92,
    y1: 59.81,
    x2: 17.2,
    y2: 70.53,
    xlinkHref: "#Gradient_38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_16",
    "data-name": "Gradient 16",
    x1: 37.93,
    y1: 64.46,
    x2: 61.37,
    y2: 64.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#ff8e30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7825"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_38-3",
    "data-name": "Gradient 38",
    x1: 46.94,
    y1: 67.06,
    x2: 44.02,
    y2: 85.51,
    xlinkHref: "#Gradient_38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_13",
    "data-name": "Gradient 13",
    x1: 36.9,
    y1: 72.64,
    x2: 55.15,
    y2: 72.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf1900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bc702a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_16-2",
    "data-name": "Gradient 16",
    x1: 58.15,
    y1: 62.92,
    x2: 58.15,
    y2: 80.65,
    xlinkHref: "#Gradient_16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_25",
    "data-name": "Gradient 25",
    x1: 41.98,
    y1: 64.21,
    x2: 62.55,
    y2: 64.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffcc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#fff89c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff681"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_75",
    "data-name": "Gradient 75",
    x1: 58.92,
    y1: 68.82,
    x2: 62.15,
    y2: 68.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d9965d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient",
    x1: 32.04,
    y1: 90.02,
    x2: 32.04,
    y2: 83.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#42000c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#4f000b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66000a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_38-4",
    "data-name": "Gradient 38",
    x1: 10.89,
    y1: 111.53,
    x2: 10.44,
    y2: 105.9,
    xlinkHref: "#Gradient_38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_16-3",
    "data-name": "Gradient 16",
    x1: 32.22,
    y1: 97.92,
    x2: 32.22,
    y2: 91.39,
    xlinkHref: "#Gradient_16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_75-2",
    "data-name": "Gradient 75",
    x1: 23,
    y1: 85.57,
    x2: 43.55,
    y2: 85.57,
    xlinkHref: "#Gradient_75"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_38-5",
    "data-name": "Gradient 38",
    x1: 2.38,
    y1: 72.71,
    x2: 19.71,
    y2: 92.06,
    xlinkHref: "#Gradient_38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_38-6",
    "data-name": "Gradient 38",
    x1: 28.54,
    y1: 81.24,
    x2: 53.92,
    y2: 81.24,
    xlinkHref: "#Gradient_38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_82",
    "data-name": "Gradient 82",
    x1: 28.36,
    y1: 82.76,
    x2: 51.56,
    y2: 81.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a53432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_75-3",
    "data-name": "Gradient 75",
    x1: 59.31,
    y1: 83.94,
    x2: 62.35,
    y2: 83.94,
    xlinkHref: "#Gradient_75"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_38-7",
    "data-name": "Gradient 38",
    x1: 23.04,
    y1: 87.68,
    x2: 23.04,
    y2: 80.37,
    xlinkHref: "#Gradient_38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_13-2",
    "data-name": "Gradient 13",
    x1: 3.77,
    y1: 86.05,
    x2: 9.98,
    y2: 86.05,
    xlinkHref: "#Gradient_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_75-4",
    "data-name": "Gradient 75",
    x1: 53.92,
    y1: 88.24,
    x2: 61.73,
    y2: 88.24,
    xlinkHref: "#Gradient_75"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_38-8",
    "data-name": "Gradient 38",
    x1: 22.18,
    y1: 84.8,
    x2: 4.18,
    y2: 54.19,
    xlinkHref: "#Gradient_38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_16-4",
    "data-name": "Gradient 16",
    x1: 25.41,
    y1: 50.81,
    x2: 25.07,
    y2: 71.07,
    xlinkHref: "#Gradient_16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_75-5",
    "data-name": "Gradient 75",
    x1: 9.61,
    y1: 62.09,
    x2: 40.83,
    y2: 62.09,
    xlinkHref: "#Gradient_75"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_16-5",
    "data-name": "Gradient 16",
    x1: 12.44,
    y1: 57.14,
    x2: 40.09,
    y2: 57.14,
    xlinkHref: "#Gradient_16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_16-6",
    "data-name": "Gradient 16",
    x1: 31.71,
    y1: 69.4,
    x2: 31.6,
    y2: 73,
    xlinkHref: "#Gradient_16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_38-9",
    "data-name": "Gradient 38",
    x1: 27.76,
    y1: 77.54,
    x2: 10.03,
    y2: 77.54,
    xlinkHref: "#Gradient_38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_16-7",
    "data-name": "Gradient 16",
    x1: 42.81,
    y1: 74.65,
    x2: 42.81,
    y2: 81.25,
    xlinkHref: "#Gradient_16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_75-6",
    "data-name": "Gradient 75",
    x1: 29.37,
    y1: 79.62,
    x2: 56.25,
    y2: 79.62,
    xlinkHref: "#Gradient_75"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_16-8",
    "data-name": "Gradient 16",
    x1: 29.6,
    y1: 76.48,
    x2: 55.92,
    y2: 76.48,
    xlinkHref: "#Gradient_16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_38-10",
    "data-name": "Gradient 38",
    x1: 8.24,
    y1: 67.46,
    x2: 25.57,
    y2: 86.82,
    xlinkHref: "#Gradient_38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_13-3",
    "data-name": "Gradient 13",
    x1: 0,
    y1: 73.22,
    x2: 23.57,
    y2: 73.22,
    xlinkHref: "#Gradient_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_13-4",
    "data-name": "Gradient 13",
    x1: 2.24,
    y1: 74.65,
    x2: 23.55,
    y2: 74.65,
    xlinkHref: "#Gradient_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_25-2",
    "data-name": "Gradient 25",
    x1: 2.35,
    y1: 64.99,
    x2: 25.4,
    y2: 64.99,
    xlinkHref: "#Gradient_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_16-9",
    "data-name": "Gradient 16",
    x1: 23.59,
    y1: 66.21,
    x2: 23.59,
    y2: 83.94,
    xlinkHref: "#Gradient_16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_75-7",
    "data-name": "Gradient 75",
    x1: 19.05,
    y1: 69.14,
    x2: 23.16,
    y2: 69.14,
    xlinkHref: "#Gradient_75"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_82-2",
    "data-name": "Gradient 82",
    x1: 30.11,
    y1: 78.2,
    x2: 76.48,
    y2: 75.39,
    xlinkHref: "#Gradient_82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_82-3",
    "data-name": "Gradient 82",
    x1: 102.63,
    y1: 66.27,
    x2: 1273.36,
    y2: -4.77,
    xlinkHref: "#Gradient_82"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2.08,39.15l15.23,25.06,4.06.07s2.93.09,4.02,1.3,3.27,9.42,3.15,11.97l6.65,20.06,25.64.38,9.66-18.36-9.12-42.63L49.03,2.16,25.94.85,6.88,0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 34.75,
    y1: 92.32,
    x2: 34.75,
    y2: 22.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbee41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#f7cc3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#f3aa3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#ef903e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#ed7d3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#ec713d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#ec6e3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#fcc612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#f18f40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#ec683b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcd740"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 37.73,
    y1: 38.08,
    x2: 39.58,
    y2: 60.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#ff8324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#fcc612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#ec683b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcd740"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\xCE\\xD3\\xC8_1",
    "data-name": "\\u2014\\xCE\\xD3\\xC8_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m4.52,74.49s-.5-4.62-1.11-13.9c0,0,.8-.65,1.59-.88l2.61,14.78h-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "m25.22,59.25s-15.91-.08-20.21.46l2.61,14.78,18.64-1.27-1.04-13.96Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m37.93,64.2s11.06-.41,18.85,1.38c0,0,2.09-.81,3.76-1.15.3-.06.58-.1.83-.13,0,0,0,0,0,0-.3-.06-8.92-1.63-19.38-.62-.01,0-.02,0-.02,0h0c-1.32.13-2.67.3-4.03.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m37.44,81.01l16.13.21,1.58-7.72,1.63-7.93s-4.76-1.65-14.52-1.53c-1.35.02-2.79.07-4.33.16,0,0-1.94,6.41-.49,16.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m37.44,81.01l16.13.21,1.58-7.72c-2.35.07-8.93.37-11.47-1.33-.85-.57-1.82-8.12-1.82-8.12-1.35.02-2.4.05-3.94.14,0,0-1.94,6.41-.49,16.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m53.32,81.69s2.38.95,5.81,0c0,0-.38-4.27.41-7.81.05-.21,2.46-1.77,3.02-3.73.65-2.29.55-3.96,0-5.08h0c-.11-.22-.25-.4-.42-.53-.18-.14-.45-.22-.76-.25,0,0,0,0,0,0-.37-.04-.82-.02-1.29.04-1.36.18-2.89.74-3.29,1.24-.66.81-3.67,8.17-3.47,16.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m41.98,63.68c.4-.03,5.43-.41,12.38.03,2.67.17,4.49.4,5.71.62.17.03.32.06.46.09,1.65.34,1.99.64,2.01.66-.11-.22-.25-.4-.42-.53-.18-.14-.45-.22-.76-.25,0,0,0,0,0,0-.3-.06-8.92-1.63-19.38-.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m61.81,65.3c.19.06,1.31,3.94-1.9,7.19,0,0,1.65-2.09,1.9-4.2.25-2.11-.73-3.12-2.89-2.71,0,0,1.54-.73,2.89-.27Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "57.87 88.43 57.54 90.61 55.48 90.61 55.02 88.51 27.38 88.51 26.92 90.61 24.81 90.61 24.25 88.56 10.12 88.56 9.39 90.61 7.28 90.61 6.77 88.71 6.11 88.71 5.3 82.59 58.79 82.12 58.79 88.34 57.87 88.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "8.83 89.14 10.49 83.87 7.76 88.01 7.25 88.79 8.83 89.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m2.08,87.38c.58.39,1.15.7,1.7.95,2.8,1.29,4.93.96,5.06.81.14-.16-1.22-.9-1.07-1.14,0,0,0,0,0,0,.02-.03.06-.04.12-.05,5.04-.81,9.81,1.27,11.26,1.76,1.45.48,3.47.15,3.47.15-.23-.33-.2-.51-.2-.51.24-.09.51-.12.75-.12.04,0,.09,0,.13,0,.23,0,.4.04.4.04,0,.18-.13.54-.13.54,4.04.8,12.7.71,20,.33.04,0,.06,0,.08,0,0,0,.02,0,.03,0,14.49.66,18.38-2.35,18.38-2.35l-.56-1.12c.87-.25.87-.89.87-.89-1.16-1.86-2.44-3.71-3.04-4.57-.22-.31-.35-.5-.35-.5-2.16,1.1-4.71,1.05-5.52,1-.16,0-.25-.02-.25-.02-6.35.11-23.41-.46-24.56-.47-.01,0-.02,0-.02,0-.74,0-1.42-.02-2.03-.05-1.39-.08-2.44-.25-3-.35-.03,0-.05,0-.07-.01-.26-.05-.4-.08-.4-.08-.03,0-.07,0-.1.01-7.64.92-18.69.2-18.69.2-.4,1.95-2.24,6.46-2.24,6.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m23.29,89.23c.23,0,.4.04.4.04,0,.18-.13.54-.13.54,4.04.8,12.7.71,20,.33-1.15.05-9.45.26-14.19-3.01-4.58-3.16-5.63-5.82-5.8-6.32l-.57-.09.07,1.16.21,7.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m2.08,87.38c.58.39,1.15.7,1.7.95,2.8,1.29,4.93.96,5.06.81.14-.16-1.22-.9-1.07-1.14,0,0,0,0,0,0,.02-.03.06-.04.12-.05,5.04-.81,9.81,1.27,11.26,1.76,1.45.48,3.47.15,3.47.15-.23-.33-.2-.51-.2-.51.24-.09.51-.12.75-.12l-.09-7.34-.07-1.16c-7.64.92-18.69.2-18.69.2-.4,1.95-2.24,6.46-2.24,6.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m28.63,80.93s-.19.75,0,.77c12.8,1.3,25.29.02,25.29.02l-.49-1.52c-10.76,1.3-24.8.73-24.8.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m26.26,81.89s2.44,1.65,4.45,1.9c2.57.32,9.07-.2,19.42-.53,1-.03,3.79-1.54,3.79-1.54l-.19-1.35c-10.76,1.3-25.1.56-25.1.56v.29s-.02,0-.02,0c-.74,0-1.42-.02-2.03-.05-.1.23-.2.47-.31.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m59.31,81.21s0,0,0,.01c.85,2.65,2.17,5.44,2.17,5.44.87-.25.87-.89.87-.89-1.16-1.86-2.44-3.71-3.04-4.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m22.41,89.35c.54-.2,1.27-.08,1.27-.08.25-1.15-.05-5.6-.61-7.38,0,0-1.12,5.04-.66,7.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m3.77,88.33c2.8,1.29,4.93.96,5.06.81.14-.16-1.22-.9-1.07-1.14,0,0,0,0,0,0,.09-.16,1.62-2.83,2.21-5.2,0,0-2.09,4.59-3.41,5.71-.25.21-1.27.13-2.79-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m54.49,89.3c6.05-1.65,7.12-2.39,7.12-2.39l.12.24s-2.32,1.94-7.78,2.43c0,0-.21-.07.54-.28Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m14.31,73.7h-6.19s-.58-4.38-1.72-11.61c-1.15-7.23-1.1-9.66-1.1-9.66,0,0,1.94-1.2,4.31-1.81l4.7,23.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m9.61,50.62c1.53,11.08,4.7,23.08,4.7,23.08h26.53c-.02-.51-.04-1.01-.06-1.51-.13-2.63-.38-5.11-.68-7.4h0s0,0,0,0c-1.15-8.76-3.16-14.64-3.16-14.64-6-1.24-18.63-.54-24.5.12h0c-.67.08-1.24.14-1.69.2-.73.09-1.14.14-1.14.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m9.61,50.62c1.53,11.08,4.7,23.08,4.7,23.08h26.53c-.02-.51-.04-1.01-.06-1.51,0,0-16.88.46-22.23-4.08-4.07-3.45-6.55-14.18-7.8-17.64-.73.09-1.14.14-1.14.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m12.44,50.28c17.07-.3,24.01.11,24.01.11,1.76,5.09,3.6,14.2,3.64,14.41-1.15-8.76-3.16-14.64-3.16-14.64-6-1.24-18.63-.54-24.5.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m55.01,74.75s-3.37-.61-14.17-1.04c0,0-16.54-.64-32.72,0,0,0,16.7,1.26,21.48,1.3.28,0,21.63-.05,25.41-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "m29.6,81.38s-14.83-.67-20.49-1.28c0,0-.92-3.62-.99-6.4,0,0,12.95.33,21.48,1.3,0,0,.34,4.25,0,6.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m29.6,81.38c12.66.71,26.65,0,26.65,0-.01-.28-.03-.56-.06-.83-.06-.73-.16-1.43-.27-2.08-.37-2.16-.91-3.72-.91-3.72-2.37-.18-5.13-.25-7.95-.26-8.5-.03-17.46.51-17.46.51-.15.81-.22,1.69-.23,2.54h0c-.03,2.03.23,3.84.23,3.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m29.6,81.38c12.66.71,26.65,0,26.65,0-.01-.28-.03-.56-.06-.83,0,0-11.48.67-18.62.31-7.02-.35-8.17-3.23-8.2-3.32-.03,2.03.23,3.84.23,3.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "m54.7,75.41c.41.63,1.15,2.65,1.22,3.06-.37-2.16-.91-3.72-.91-3.72-.15-.01-.29-.02-.44-.03,0,0,0,0-.01,0-.14,0-.29-.02-.44-.03,0,0-.02,0-.02,0-.14,0-.28-.02-.43-.02-.02,0-.03,0-.05,0-.13,0-.27-.01-.4-.02-.03,0-.06,0-.1,0-.12,0-.24-.01-.36-.02-.05,0-.11,0-.16,0-.1,0-.2,0-.3-.01-.08,0-.15,0-.23,0-.08,0-.15,0-.23,0-.1,0-.21,0-.31-.01-.05,0-.1,0-.15,0-.14,0-.27,0-.41-.01-.02,0-.04,0-.06,0-1.25-.04-2.54-.05-3.84-.06h0c-8.5-.03-17.46.51-17.46.51,0,0,9.91-.04,14.9,0,.47,0,.95,0,1.43,0h0s.02,0,.04,0c.72,0,1.44-.01,2.13-.02,0,0,4.94.08,6.59.43Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m.08,70.77c.27,1.99,1.31,3.2,2.17,3.87.65.51,1.2.71,1.2.71,0,0,.13.49.29,1.24.28,1.27.65,2.82.58,4.33,0,0,8.02,1.18,18.63.7,0,0,.62-1.33.62-1.33v-5.61l-.02-.11-.06-.28-.11-.53-.21-.99-1.72-8.17-.07-.33h0s-9.27-.44-18.39,1.3c0,0-.26.03-.63.17,0,0,0,0,0,0-.86.33-2.28,1.25-2.35,3.76,0,.39.01.81.07,1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m.08,70.77c.47,3.51,3.36,4.59,3.36,4.59,0,0,.13.49.29,1.24,0,0,10.64-2.41,14.81-1.59,4.16.82,5.03,1.94,5.03,1.94l-.19-3.17-.06-.89-.15-.1-4.54-2.92s-.05,2.52-2.34,3.18c-2.29.66-12.59,1.5-14.52,0-1.24-.97-1.65-2.34-1.76-3.54,0,.39.01.81.07,1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m2.24,74.64c.65.51,1.2.71,1.2.71,9.75-1.53,19.26-.87,19.26-.87l.85.1-.06-.28c-.36-.06-.78-.12-1.24-.19-3.96-.58-20,.53-20,.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m2.35,65.74c5.46-1.19,14.23-1.33,17.73-1.21.22,0,.42.02.6.02.27.01.52.03.76.05,2.48.22,3.82.83,3.95.97-.48-.59-2.54-1.26-4.02-1.3h0s-9.27-.44-18.39,1.3c0,0-.26.03-.63.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "m18.98,70.92c1.02,1.88,3.67,3.36,3.71,3.56.78,3.48.25,7.14.25,7.14,1.27.21,2.4.26,3.32.26,1.47-.01,2.37-.19,2.37-.19.06-2.39-.15-4.73-.49-6.85h0c-.79-4.94-2.28-8.7-2.75-9.27-.48-.59-2.54-1.26-4.02-1.3-.54-.01-1.01.06-1.29.25-.01,0-.02.02-.04.02-1.02.76-2.15,4.37-1.06,6.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22.12,73.04s-2.8-1.63-3.03-3.24c-.23-1.61.59-4,.99-4.56,0,0,1.63-.18,3.08.92,0,0-1.94-.86-2.65-.42-.71.44-1.27,2.99-.87,4.34.41,1.35,2.47,2.96,2.47,2.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m26.26,81.89c1.47-.01,2.37-.19,2.37-.19.06-2.39-.15-4.73-.49-6.85-.02.06-1.32,3.96-1.88,7.04Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m59.53,73.89c.05-.21,2.46-1.77,3.02-3.73.65-2.29.55-3.96,0-5.08h0c-.11-.22-.25-.4-.42-.53-.18-.14-.45-.22-.76-.25,0,0,0,0,0,0-.3-.06-8.92-1.63-19.38-.62-.01,0-.02,0-.02,0h0c-.66.06-1.32.14-1.99.22-1.17-8.26-3.03-13.75-3.03-13.75-6-1.24-18.63-.54-24.5.12h0c-.67.08-1.24.14-1.69.2-.73.09-1.14.14-1.14.14-2.37.6-4.31,1.81-4.31,1.81,0,0-.04,1.86.72,7.19-.38.03-.72.06-1.01.1-.79.22-1.59.88-1.59.88.12,1.79.23,3.4.34,4.85-.26.05-.51.09-.77.14,0,0-.26.03-.63.17,0,0,0,0,0,0-.86.33-2.28,1.25-2.35,3.76,0,.39.01.81.07,1.27,0,.02,0,.03,0,.05.03.22.07.43.12.62.02.08.04.15.06.23.04.13.07.26.12.38.03.08.06.16.09.23.04.11.09.21.14.32.04.08.07.15.11.22.05.09.1.19.15.27.04.07.08.13.12.2.06.09.11.17.17.25.04.06.08.11.13.17.06.08.13.15.19.23.04.04.08.09.12.13.08.09.16.16.24.24.02.02.05.05.07.07.11.1.21.18.31.27,0,0,0,0,0,0,0,0,.01,0,.02.01.15.12.29.21.42.3.01,0,.03.02.04.03.13.08.24.15.34.2.02,0,.03.02.05.03.09.05.17.08.22.11.02,0,.02.01.04.02.03.01.06.02.06.02,0,0,0,0,0,0,0,0,.13.49.29,1.24.28,1.27.65,2.82.58,4.33-.4,1.95-2.24,6.46-2.24,6.46.58.39,1.15.7,1.7.95,1.21.56,2.29.8,3.14.9l.37,1.37h2.1l.74-2.05h5.58c1.6.44,2.83.94,3.45,1.15,1.45.48,3.47.15,3.47.15-.23-.33-.2-.51-.2-.51.11-.04.23-.07.34-.08.02,0,.04,0,.05,0,.11-.01.22-.02.32-.02.04,0,.07,0,.11,0,0,0,.01,0,.02,0,.05,0,.1,0,.15,0,0,0,.02,0,.03,0,.05,0,.09,0,.13.01,0,0,0,0,0,0,.08,0,.12.02.12.02,0,.18-.13.54-.13.54.33.07.7.12,1.08.18l.17.62h2.11l.08-.38c4.5.33,10.92.2,16.55-.08.04,0,.06,0,.08,0,0,0,.02,0,.03,0,5.09.23,8.86.01,11.63-.37l.18.84h2.07l.19-1.27c3.21-.7,4.31-1.55,4.31-1.55l-.32-.64h0l-.12-.24h0l-.12-.24c.87-.25.87-.89.87-.89-1.16-1.86-2.44-3.71-3.04-4.57-.1-.14-.18-.25-.24-.33-.07-1.41-.12-4.39.46-6.99Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m49.23,63.5c7.55,2.07,10.08,16.42,10.08,16.42l-4.58,9.52-.24,2.05h-3.27s5.37-10.77,5.37-10.77c0,0-7.83-6.36-8.22-6.33-1.16.1-2.24.09-3.24-.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "54.49 91.49 51.22 91.49 52.24 89.45 54.72 89.45 54.72 89.45 54.49 91.49"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "32.07 43.51 38.74 48.4 49.81 42.97 50.67 45.77 47.37 46.45 38.34 51.41 29.2 46.39 32.07 43.51"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m21.86,22.44s.25-3.39.93-3.91,1.3-2.06,1.23-3.48c-.07-1.42.56-1.77,1.08.33,1.08-.75,1.47-1.04,1.47-1.04,0,0,.78-2.28,1-2.97.22-.68.38-3.19.72-3.31.34-.12.53,1.93.53,2.56,0,.63-.72,3.25-.72,3.25,0,0,1.98-2.46,2.03-2.98.05-.51.54-3.76.83-4.05.28-.29.64,2.44.65,3.24s-.95,3.31-.95,3.31c0,0,2.21-2.01,2.43-2.47.22-.46,1.32-6.62,1.72-7.19.39-.57.96-1.15.91,0-.05,1.14-.98,7.01-1.25,7.92-.28.91-3.68,3.5-3.68,3.5,0,0,1.76-.75,1.99-.92.23-.17.18.68-.56,1.2s-1.36,1.09-2.1,1.21-4.26,1.05-5.34,1.92-1.74,3.86-1.74,3.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m21.79,22.91c.24.12-.79-1.18-2.14-2.21-1.36-1.03-3.85-.87-6.84-1.41s-5.1-3.47-5.64-5.15,1.57,1.74,3.91,2.39c-2.33-2.6-3.15-5.32-3.36-6.24-.22-.92.81-2.98,1.03-3.31.22-.33.16,2.33.22,3.47.05,1.14,1.57,2.66,1.57,2.66,0,0-.33-5.21,0-6.67.33-1.46,1.13-3.8,1.65-4.18.52-.38.18,1.9,0,4.07s.25,5.81.36,6.24c.11.43,1.25,1.89,1.25,1.89,0,0,.16-3.63.38-4.99.22-1.36.6.05.92,1.36.33,1.3.43,4.99.87,5.37s2.01,1.3,2.01,1.3c0,0-.54-1.68-.16-2.01.38-.33,1.25,2.77,1.74,3.36.49.6,1.7,1.46,2.07,1.74.37.27.75,2.06.75,2.06l-.57.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m24.58,22.91s1.83-4.33,5.19-4.43c-.29,2.88-2.4,3.85-5.19,4.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m25.77,22.18s1.44-2.89,3.73-3.21c-.21,1.98-1.91,3.1-2.99,3.43-.72.23-.74-.21-.74-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m22.88,22.07s13.05.55,14.88.83c4.59-.46,5.79,0,5.79,0,0,0,.09,7.72-2.3,9.46-2.39,1.75-6.25-.37-7.35-3.22-1.1-2.85.54-4.72,1.93-5.51,1.39-.8,1.38,5.14,1.38,5.14l-1.38,1.1-7.99-.28s-.64-2.2,2.02-2.66c2.66-.46,3.77,8.18,4.69,11.12.92,2.94,2.57,10.09,2.57,10.09,0,0,.57.41,3.6,1.33,3.03.92,12.09,5.61,10.37,16.34-.88,5.49-13.95,16.45-16.63-2.01-.03-.18,3.72-.4,7.3.75,6.62,2.13,8.23,16.19,8.23,16.19l-5.04,9.52-.24,2.05h-3.96s6.52-10.77,6.52-10.77c0,0-8.99-6.36-9.37-6.33-1.16.1-2.24.09-3.24-.01-1.29-.13-2.37-.09-3.46-.1-6.61-.04-10.12-1.26-12.42-11.27-1.94-8.41,1.81-36.9,1.99-39.38.18-2.48,2.11-2.39,2.11-2.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m37.76,22.89c4.59-.46,5.79,0,5.79,0,0,0,.09,7.72-2.3,9.46-2.39,1.75-6.25-.37-7.35-3.22-1.1-2.85.54-4.72,1.93-5.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m21.79,23.48s-3.27-3.94-9.61-2.31c2.5,4.04,6.82,4.42,9.61,3.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m36.93,30.75s-.08-.02-.1-.06c-.03-.06-.01-.13.05-.16.08-.04,1.89-1.03,2.95-.84,1.07.18,1.59.85,1.62.87.04.05.03.12-.02.16-.05.04-.12.03-.16-.02,0,0-.49-.62-1.47-.79-.99-.17-2.79.81-2.8.82-.02,0-.04.01-.06.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m39.27,26.92s-.3-1.34-1.63-1.51c-1.34-.18-.62,1.25,1.63,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m41.05,26.92s.68-1.72,1.75-1.28-.68,1.13-1.75,1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m32.62,30.46c-.14-.42-.24-.68-.24-.68,0,0,0,0,0,0h-4.81s4.53,4.19,6.36,5.87c-.37-1.62-.79-3.55-1.32-5.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m21.06,23.65s-3.82-2.82-7.13-1.98c.64,2.05,3.77,2.82,6.96,2.65.23-.49.16-.68.16-.68Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m26.92,24.34s.15.71-.65.95c-.8.25-.97-1.19-.97-1.19,0,0,1.12.01,1.62.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m27.17,24.41s-.01,0-.02,0c-.02,0-1.54-.35-2.83-.21-.04,0-.07-.02-.08-.06s.02-.07.06-.08c1.32-.15,2.86.21,2.88.21.04,0,.06.05.05.08,0,.03-.04.05-.07.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m26.58,24.23s.03.82-.59.81c-.62-.01-.69-.94-.69-.94,0,0,.94.02,1.28.13Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m26.93,23.29s-.27-1.01-.66-1.16c-.39-.15-2.13.61-2.35.68-.22.06-.17.73-.17.73l3.18-.25Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m30.2,24.07s.22.69-.56,1.01c-.77.32-1.08-1.1-1.08-1.1,0,0,1.12-.09,1.63.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m27.83,24.17s-.06-.02-.07-.06c0-.04.02-.07.05-.08,1.3-.27,2.87-.06,2.89-.06.04,0,.06.04.06.08,0,.04-.04.06-.08.06-.02,0-1.57-.21-2.84.06,0,0,0,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m29.86,23.99s.11.82-.51.87c-.62.05-.78-.87-.78-.87,0,0,.94-.07,1.29,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m27.3,23.12s.27-1.01.66-1.16c.39-.15,2.13.61,2.35.68.22.06.17.73.17.73l-3.18-.25Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m47.26,70.59s-.09-.03-.11-.07c-3.41-8.59-12.82-6.62-12.91-6.6-.06.01-.12-.03-.14-.09-.01-.06.03-.12.09-.14.1-.02,9.69-2.04,13.17,6.74.02.06,0,.13-.06.15-.01,0-.03,0-.04,0Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "44.7 92.32 40.74 92.32 42.4 89.58 45.19 89.68 44.94 90.27 44.7 92.32"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m37.89,77.21s-1.68-1.36-3.24-1.43c-.74-.03-1.76-.13-2.64-.23-1.08-.12-1.99-.82-2.38-1.84l-2.03-5.37c-.6-1.59-1.83-2.9-3.43-3.5-1.22-.46-2.71-.75-4.1-.33l7.37,12.41,10.44.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "m31.6,45.79l3.25,3.84c1.18,1.09,2.81,2.55,4.38,2.25l9.87-1.69,2-.57v3.51l-2.42-.44-10.22,2.53c-1.37.38-2.84.16-4.05-.6l-8.15-5.14"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m53.71,46.65l.22-.06c.25-.06.52.01.7.2l.75.79c.19.2.25.48.16.74l-.25.69c-.06.18-.2.33-.37.41l-.24.11s-.35.77-1.18,1.11c0,0-.47.16-.68.71s-1.02,3.21-3.08,2.5c-2.06-.71.3-3.96.3-3.96,0,0-.58.14-1.25-.36s-.2-1.16-.2-1.16l-.62-.51s-.82.26-1.36-.46c0,0-2.12,1.41-2.96.65s.21-2.29,1.24-3.02c.83-.59,1.53-.87,1.53-.87,0,0-.27-1.13.83-1.58,1.15-.47,1.95.14,1.95.14l.39-.14c.22-.08.47-.05.66.09l.89.63c.27.19.37.53.26.84l-.14.38,2.45,2.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m49.36,48.11c.66.59,1.46.29,1.46.29l.18.2c.81.99,2.17.88,2.17.88,1.88-.3,1.75-1.47,1.75-1.47l.63-.11c.03.13.03.27-.02.4l-.25.69c-.06.18-.2.33-.37.41l-.24.11s-.35.77-1.18,1.11c0,0-.47.16-.68.71s-1.02,3.21-3.08,2.5c-2.06-.71.3-3.96.3-3.96,0,0-.58.14-1.25-.36s-.2-1.16-.2-1.16l.5-.75c-.02.23.27.5.27.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m44.89,45.03c.52-.36.98-.61,1.26-.75l.34-.97c-.2.68.11,1.06.23,1.18.66.63,1.18.47,1.18.47l.68.57c.37.26.48.75.27,1.01-.2.26-.7.25-.7.25,0,0-.19.43-.25.71-.06.28.08.36.08.36,0,0-.82.26-1.36-.46,0,0-2.12,1.41-2.96.65s.21-2.29,1.24-3.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m51.3,43.45c.15.19.19.45.1.69l-.14.37-.34-.33s.64-.26.38-.73Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-26",
    cx: 50.13,
    cy: 47.66,
    rx: 0.43,
    ry: 0.63,
    transform: "translate(-11.53 78.99) rotate(-70.49)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 48.05,
    cy: 45.83,
    rx: 0.43,
    ry: 0.63,
    transform: "translate(-11.19 75.81) rotate(-70.49)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m51.26,44.52l1.94,1.69-1.5.77c-.16.08-.36.05-.5-.07l-1.75-1.68c-.11-.1-.08-.28.06-.35l1.41-.69.34.34Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 50.25,
    cy: 47.37,
    rx: 0.55,
    ry: 0.72,
    transform: "translate(-11.18 78.92) rotate(-70.49)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 48.1,
    cy: 45.53,
    rx: 0.55,
    ry: 0.72,
    transform: "translate(-10.87 75.66) rotate(-70.49)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m53.29,47.32c-.05.13.05.28.22.34s.34,0,.39-.12-.05-.28-.22-.34-.34,0-.39.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m53.25,48.19c-.05.13.05.28.22.34s.34,0,.39-.12-.05-.28-.22-.34-.34,0-.39.12Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 52.53,
    cy: 47.31,
    rx: 0.25,
    ry: 0.32,
    transform: "translate(-9.61 81.03) rotate(-70.49)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m52.19,48.08c-.05.13.05.28.22.34s.34,0,.39-.12-.05-.28-.22-.34-.34,0-.39.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m49.3,43.56l-.19.09s-.09.02-.13.02l-.28-.06s-.09-.05-.09-.11v-.11s.02-.08.06-.1l.29-.14s.08-.01.12.02l.25.21c.06.05.05.15-.02.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m49.16,44.24l-.18.07c-.09.03-.19.01-.25-.05l-.21-.2s-.04-.07-.04-.11l.02-.11c.01-.07.07-.11.14-.1l.22.04s.09.03.12.06l.21.2c.07.06.04.17-.04.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m48.39,43.49l.06-.17s0-.1-.03-.13l-.2-.18s-.12-.06-.19-.04l-.23.08c-.08.03-.11.14-.04.2l.16.16s.08.06.13.07l.27.05s.06-.01.07-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m48.26,43.87l.04-.13s-.01-.07-.04-.08l-.32-.08c-.06-.02-.13-.02-.19,0l-.21.04c-.09.02-.13.13-.06.2l.16.17c.06.06.15.09.23.07l.26-.06c.06-.02.11-.06.13-.13Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "48.31 52.74 48.77 50.2 51.1 49.62 51.1 53.13 48.68 52.69 48.31 52.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m46.84,53.15l-7.99,2.02c-1.64.41-3.38.15-4.82-.73l-7.76-4.96"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFortunio);
export default __webpack_public_path__ + "static/media/fortunio.f08d059fef25a6c7642d6aeb8ebeb809.svg";
export { ForwardRef as ReactComponent };